import { JtechAxios } from 'src/plugins/axios'

export const TicketRepository = {
  downloadTicketImage: async function (id) {
    return await JtechAxios.request().get(`ticketImage/download/${id}`, {
      responseType: 'blob',
      headers: { Accept: 'image/jpg' }
    })
  }
}
